import { useLayoutEffect } from 'react';

/** Locks the document scroll while mounted, padding for the scrollbar so the page does not shift. */
export function useScrollLock({ autoLock = true }: { autoLock?: boolean } = {}): void {
  useLayoutEffect(() => {
    if (!autoLock) return;
    const { body } = document;
    const { overflow, paddingRight } = body.style;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${Number.parseInt(getComputedStyle(body).paddingRight, 10) + scrollbarWidth}px`;
    }
    return () => {
      body.style.overflow = overflow;
      body.style.paddingRight = paddingRight;
    };
  }, [autoLock]);
}
